"use client";

import React, { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";

export default function StorySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0 }
    );
    sectionRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      id="story"
      ref={sectionRef}
      className="section-pad bg-pmu-warm relative overflow-hidden">

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left: Image */}
          <div className="reveal-hidden relative order-2 md:order-1">
            <div className="relative rounded-3xl shadow-lift flex items-center justify-center" style={{ minHeight: "420px" }}>
              <AppImage
                src="/assets/images/cookie_compressed-1774118314233.jpg"
                alt="Cross-section of an oat and chickpea chocolate chip cookie revealing its dense golden interior"
                width={560}
                height={700}
                className="object-contain w-full h-auto max-h-[700px] rounded-3xl"
                sizes="(max-width: 1024px) 100vw, 50vw" />

            </div>
            {/* Floating badge */}
            <div
              className="absolute -bottom-5 -right-5 bg-white rounded-2xl px-5 py-4 shadow-card hidden sm:block"
              style={{ border: "1px solid rgba(214, 207, 196, 0.5)" }}>

              <p className="text-xs text-pmu-taupe uppercase tracking-widest mb-1" style={{ letterSpacing: "0.12em" }}>Made from</p>
              <p className="font-fraunces font-semibold text-pmu-espresso text-sm">Chickpeas &amp; Oats</p>
            </div>
          </div>

          {/* Right: Narrative */}
          <div className="space-y-8 order-1 md:order-2">
            <div className="reveal-hidden">
              <p className="text-xs font-medium uppercase tracking-widest text-pmu-taupe mb-6" style={{ letterSpacing: "0.2em" }}>
                Cookies That Care
              </p>
              <h2
                className="font-fraunces font-bold text-pmu-espresso leading-tight"
                style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>

                TIRED OF DOING MY STEPS AND STILL NOT BEING ABLE TO HAVE A COOKIE...I NEED A SERIOUS PICK ME UP! 
              </h2>
            </div>

            <div className="reveal-hidden delay-1">
            </div>

            <div className="reveal-hidden delay-2 w-12 h-px bg-pmu-stone" />

            <div className="reveal-hidden delay-2">
              <p className="font-fraunces text-xl font-light text-pmu-espresso italic leading-relaxed mb-4">
                &ldquo;Finally, a cookie my fitness trainer would be proud of.&rdquo;
              </p>
            </div>

            {/* Minimal stats */}
            <div className="reveal-hidden delay-3 grid grid-cols-2 gap-3">
              {[
              { value: "9g", label: "Protein" },
              { value: "4g", label: "Fibre" },
              { value: "0", label: "Dairy / Eggs" },
              { value: "Low", label: "Glycemic Index" }]?.
              map(({ value, label }) =>
              <div
                key={label}
                className="p-5 rounded-2xl"
                style={{ background: "#FFFFFF", border: "1px solid rgba(214, 207, 196, 0.5)" }}>

                  <p className="font-fraunces font-bold text-2xl text-pmu-espresso leading-none mb-1">
                    {value}
                  </p>
                  <p className="text-xs text-pmu-taupe uppercase tracking-wider" style={{ letterSpacing: "0.1em" }}>
                    {label}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}